import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import { ClientVisitListAdminScreen } from "./ClientVisitListAdminScreen";
import { ClientVisitListClientScreen } from "./ClientVisitListClientScreen";

export function ClientVisitListScreen() {
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    return isAdmin ? <ClientVisitListAdminScreen /> : <ClientVisitListClientScreen />;
}
